<template>
    <div class="body-info body-content-description themed-scrollbar">
        <p class="content-description"> {{ kStrings.kGLOB_TITLE + ':' }} <span > {{ modalData.content.title }} </span> </p>
        <p class="content-description"> {{ kStrings.kGLOB_TEXT_BODY + ':' }}  <span> {{ modalData.content.description }} </span> </p>
    </div>
</template>

<script>

import {store} from '@/store/pastimes';
import {isEmpty} from 'lodash-es';

export default {
    store,
    name: 'TextBodyDescription',
    components: {},
    props: {
        prop1: {type: Object, default: null, required: false}
    },
    data() {
        return {
            data1: null
        }
    },
    computed: {
        kStrings() {
            return this.$store.getters.kStrings;
        },
        modalData() {
            return this.$store.getters.modalData;
        },
    },
    watch: {
        watched1(value) { }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        method1() { }
    }
};
</script>

<style scoped>

</style>